/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
import * as firebase from 'firebase/app';
import "firebase/auth";
import "firebase/firestore";
import 'firebase/functions';
import { firebase as config } from '../config';
class UserUtil {
    static createByFirebaseUser(firebaseUser) {
        return {
            uid: firebaseUser.uid,
            displayName: firebaseUser.displayName
        };
    }
}
export class FirebaseAdapter {
    get user() {
        return Promise.resolve(this.currentUser()
            .then(user => user ? UserUtil.createByFirebaseUser(user) : null));
    }
    constructor() {
        this.app = firebase.initializeApp(config.app.options, config.app.name);
        this.auth = this.app.auth();
        this.firestore = this.app.firestore();
        this.functions = this.app.functions(config.functions.region);
        this.firestore.settings(config.firestore.settings);
    }
    signInAnonymously() {
        return new Promise((resolve, reject) => {
            this.auth.signInAnonymously()
                .then(credential => credential.user)
                .then(user => user ? resolve(UserUtil.createByFirebaseUser(user)) : reject('Sign in failed'));
        });
    }
    async fetchDocumentData(documentPath) {
        const doc = await this.firestore.doc(documentPath).get();
        return doc.exists ? doc.data() : null;
    }
    watchDocumentData(documentPath) {
        return new Promise(resolve => {
            const unsubscribe = this.firestore.doc(documentPath).onSnapshot(doc => {
                if (doc.exists) {
                    unsubscribe();
                    resolve(doc.data());
                }
            });
        });
    }
    deleteDocument(documentPath) {
        return this.firestore.doc(documentPath).delete();
    }
    async callHttps(name, data) {
        const callable = this.functions.httpsCallable(name);
        const response = await callable(data);
        return response.data.data;
    }
    async setUserDisplayName(displayName) {
        const user = await this.currentUser();
        if (user) {
            await user.updateProfile({
                displayName
            });
        }
    }
    signOut() {
        return this.auth.signOut();
    }
    currentUser() {
        return new Promise((resolve) => {
            const unsubscribe = this.auth.onAuthStateChanged(user => {
                resolve(user);
            }, error => {
                throw error;
            }, () => {
                unsubscribe();
            });
        });
    }
}
